// components/GlobalAvailabilityMap.js
import { Box, Center, Grid, Stack, Skeleton } from '@mantine/core'
import ParentSize from '@visx/responsive/lib/components/ParentSize'
import dynamic from 'next/dynamic'
import TitleDivider from '../divider'
import { getText } from '../../utils/constants'

const Chloropleth = dynamic(() => import('../viz/world'), {
  ssr: false
})

const GlobalAvailabilityMap = ({
  availablePlatforms,
  setCountry,
  isLoading,
  name
}) => {
  const t = (key) => getText('GlobalAvailability', key)

  if (isLoading) {
    return (
      <Grid.Col span={8}>
        <Skeleton height={600} />
      </Grid.Col>
    )
  }

  return (
    <Grid.Col
      span={8}
      p={5}
      sx={(theme) => ({
        [theme.fn.smallerThan('md')]: {
          width: '100%',
          maxWidth: '100%',
          flex: '0 0 100%'
        }
      })}
    >
      <Box>
        <Stack spacing={8} sx={{ gap: '0' }}>
          <TitleDivider titleText={t('globalAvailability') + name.toUpperCase()} />{' '}
        </Stack>
        <Center sx={{ height: '613.5px' }} mt={5}>
          <ParentSize>
            {({ width, height }) => (
              <Chloropleth
                width={width}
                height={height}
                data={availablePlatforms.available_countries}
                setCountry={setCountry}
              />
            )}
          </ParentSize>
        </Center>
      </Box>
    </Grid.Col>
  )
}

export default GlobalAvailabilityMap
